import { Injectable } from '@angular/core';
import { DataEntryHistory } from '@osos/shared/api';
import { EntryHistoryPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';

@Injectable()
export class DataEntryHistoryParserV1Service extends ParserBase<
  DataEntryHistory,
  EntryHistoryPresenterModel
> {
  constructor() {
    super(DataEntryHistory, EntryHistoryPresenterModel, 1);
  }
  getPresenterModel(model: DataEntryHistory): EntryHistoryPresenterModel {
    return {
      actionInfo: model.actionInfo,
      historyType: model.historyType,
      additionalData: model.additionalData,
      invalidReason: model.invalidReason,
    } as EntryHistoryPresenterModel;
  }
  getDataModel(presenter: EntryHistoryPresenterModel): DataEntryHistory {
    const model = {
      actionInfo: presenter.actionInfo,
      historyType: presenter.historyType,
      additionalData: presenter.additionalData,
      invalidReason: presenter.invalidReason,
    } as DataEntryHistory;

    return model;
  }
}
